/**
 * NumberOfDaysDropdown
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../services/router/actions';

// Workspaces
import { makeSelectQueryStringNumberValue } from '../../workspaces/react-router-selectors';

interface Props {
    updateQueryString: Function;
    numberOfDays?: ?number;
}

export class NumberOfDaysDropdown extends React.Component<Props> {
    static defaultProps = {
        numberOfDays: 7
    };

    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: number }
    ) => {
        this.props.updateQueryString({
            numberOfDays: data.value
        });
    };

    render() {
        const { numberOfDays } = this.props;
        return (
            <Dropdown
                compact
                selection
                fluid
                selectOnBlur={false}
                value={numberOfDays}
                options={[
                    { key: 1, text: 'Day', value: 1 },
                    { key: 7, text: 'Week', value: 7 }
                ]}
                onChange={this.handleChange}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    numberOfDays: makeSelectQueryStringNumberValue('numberOfDays')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(NumberOfDaysDropdown);
